import { render, staticRenderFns } from "./OrganizationalMetric.vue?vue&type=template&id=294ec9f5&scoped=true"
import script from "./OrganizationalMetric.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationalMetric.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationalMetric.vue?vue&type=style&index=0&id=294ec9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ec9f5",
  null
  
)

export default component.exports